import { gql } from '@efficiently/client-core-graphql-models';

export const PROJECT_DESIGN_CHANGE_FIELDS = gql(`
	fragment ProjectDesignChange on ProjectDesignChange {
		_id
		number
		oiNumber
		name
		description
		generalNotes
		internalNotes
		rationale
		rationaleOther
		status
		createdDate
		items {
			...ProjectDesignChangeItem
		}
	}
`);
